/**
 * Accessory / cover / undies / keychain / Mikaila PDP
 * Same Model + Color (or single-option) picker + gallery rebuild as the pillow PDP.
 */
(function () {
  'use strict';

  var COLOR_DISPLAY_ORDER = ['Beige', 'Charcoal', 'Black', 'Mocha'];
  var COLOR_DEFAULT_PREF = ['Beige', 'Charcoal', 'Black', 'Mocha'];

  function money(cents, currency) {
    try {
      return (cents / 100).toLocaleString(undefined, {
        style: 'currency',
        currency: currency || 'USD',
      });
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function modelKey(sizeValue) {
    return String(sizeValue || '')
      .split('(')[0]
      .trim()
      .toUpperCase();
  }

  function isAssortedColor(name) {
    var l = String(name || '').toLowerCase();
    return (
      l.indexOf('ass-orted') >= 0 ||
      l.indexOf('assorted') >= 0 ||
      l.indexOf('mixed') >= 0
    );
  }

  function sortColors(list, handle) {
    return list.slice().sort(function (a, b) {
      // Keychains: Ass-orted (red/white/blue mix) first
      if (handle === 'mini-butt-keychain') {
        var aAss = isAssortedColor(a.color) ? 0 : 1;
        var bAss = isAssortedColor(b.color) ? 0 : 1;
        if (aAss !== bAss) return aAss - bAss;
        return String(a.color || '').localeCompare(String(b.color || ''));
      }
      var ia = COLOR_DISPLAY_ORDER.indexOf(a.color);
      var ib = COLOR_DISPLAY_ORDER.indexOf(b.color);
      if (ia === -1) ia = 999;
      if (ib === -1) ib = 999;
      if (ia !== ib) return ia - ib;
      return 0;
    });
  }

  function displaySizeLabel(size, handle) {
    if (handle === 'the-official-mikaila-murphy-buttress-pillow') {
      var low = String(size || '').toLowerCase();
      if (low.indexOf('mini') >= 0) return 'Mini Mikaila';
      return 'The Mikaila';
    }
    var key = modelKey(size);
    if (key === 'ODB' || key === 'OMG' || key === 'ORT') {
      var m = String(size || '').match(/\(([^)]+)\)/);
      return key + (m ? ' (' + m[1] + ')' : '');
    }
    return size;
  }

  function init(root) {
    if (!root || root.dataset.tbpAccBound) return;
    var data = window.TBP_ACC_PRODUCT;
    if (!data || !data.variants) return;
    root.dataset.tbpAccBound = '1';

    var sizeOption = data.options.find(function (o) {
      return ['size', 'model'].indexOf(String(o.name || '').toLowerCase()) >= 0;
    });
    var colorOption = data.options.find(function (o) {
      return ['color', 'colour'].indexOf(String(o.name || '').toLowerCase()) >= 0;
    });
    // Fallback: first non-color option as size/model text picker
    if (!sizeOption) {
      sizeOption = data.options.find(function (o) {
        return ['color', 'colour'].indexOf(String(o.name || '').toLowerCase()) < 0;
      });
    }

    // Undies / keychains are color pickers only — never show a "Model" row.
    // Shopify often names their single option "Title" / "Model" instead of "Color".
    var colorOnlyHandles = {
      'the-buttress-pillow-spandex-undies': true,
      'mini-butt-keychain': true,
    };
    var isColorOnlyProduct =
      !!colorOnlyHandles[data.handle] ||
      (!!root.classList && root.classList.contains('tbp-acc--color-only'));
    if (isColorOnlyProduct) {
      // Prefer a real Color option; otherwise reuse the lone option as color
      if (!colorOption) {
        colorOption =
          sizeOption ||
          (data.options && data.options[0]) ||
          null;
      }
      sizeOption = null;
      data.variants.forEach(function (v) {
        if (!v.color && v.size) v.color = v.size;
        // If liquid put the value on option1 as size only, keep color in sync
        if (!v.color && v.option1) v.color = v.option1;
      });
      if (!data.selectedColor && data.selectedSize) {
        data.selectedColor = data.selectedSize;
      }
    }

    var mode = 'single';
    if (sizeOption && colorOption) mode = 'model-color';
    else if (colorOption && !sizeOption) mode = 'color';
    else if (sizeOption && !colorOption) mode = 'model';

    var params = new URLSearchParams(window.location.search);
    var variantIdParam = String(params.get('variant') || '').trim();
    var modelParam = String(params.get('model') || '').trim().toUpperCase();
    if (!modelParam && variantIdParam && !/^\d+$/.test(variantIdParam)) {
      modelParam = variantIdParam.toUpperCase();
      variantIdParam = '';
    }

    var selectedSize = data.selectedSize || null;
    var selectedColor = data.selectedColor || null;
    var mediaIndex = 0;

    if (variantIdParam && /^\d+$/.test(variantIdParam)) {
      var fromVariant = data.variants.find(function (v) {
        return String(v.id) === variantIdParam;
      });
      if (fromVariant) {
        if (fromVariant.size) selectedSize = fromVariant.size;
        if (fromVariant.color) selectedColor = fromVariant.color;
      }
    }

    if (mode === 'model-color' || mode === 'model') {
      var fromUrl = null;
      if (modelParam && sizeOption) {
        fromUrl = sizeOption.values.find(function (v) {
          return modelKey(v) === modelParam;
        });
      }
      selectedSize = fromUrl || selectedSize || (sizeOption && sizeOption.values[0]) || null;
    }
    if (mode === 'color' || mode === 'model-color') {
      if (data.handle === 'mini-butt-keychain' && colorOption && !variantIdParam) {
        var assortedVal = colorOption.values.find(function (v) {
          return isAssortedColor(v);
        });
        selectedColor = assortedVal || selectedColor || data.selectedColor || colorOption.values[0];
      } else if (!selectedColor && colorOption) {
        selectedColor = data.selectedColor || colorOption.values[0];
      }
    }

    var els = {
      slider: root.querySelector('[data-acc-slider]'),
      thumbs: root.querySelector('[data-acc-thumbs]'),
      dots: root.querySelector('[data-acc-dots]'),
      price: root.querySelector('[data-acc-price]'),
      compare: root.querySelector('[data-acc-compare]'),
      models: root.querySelector('[data-acc-models]'),
      colors: root.querySelector('[data-acc-colors]'),
      modelLabel: root.querySelector('[data-acc-model-label]'),
      colorLabel: root.querySelector('[data-acc-color-label]'),
      variantInput: root.querySelector('[data-acc-variant-id]'),
      buyNow: root.querySelector('[data-acc-buy-now]'),
      addCart: root.querySelector('[data-acc-add-cart]'),
      error: root.querySelector('[data-acc-error]'),
    };

    function variantsForSize(size) {
      return data.variants.filter(function (v) {
        return v.size === size;
      });
    }

    function findVariant() {
      if (mode === 'model-color') {
        return data.variants.find(function (v) {
          return v.size === selectedSize && v.color === selectedColor;
        });
      }
      if (mode === 'color') {
        return data.variants.find(function (v) {
          return v.color === selectedColor;
        });
      }
      if (mode === 'model') {
        return data.variants.find(function (v) {
          return v.size === selectedSize;
        });
      }
      return data.variants[0];
    }

    function ensureColorForSize() {
      if (mode !== 'model-color') return;
      var list = sortColors(variantsForSize(selectedSize));
      if (!list.length) return;
      var next = list.find(function (v) {
        return v.color === selectedColor && v.available;
      });
      if (!next) {
        next = COLOR_DEFAULT_PREF.map(function (c) {
          return list.find(function (v) {
            return v.color === c && v.available;
          });
        }).find(Boolean);
      }
      if (!next) next = list.find(function (v) { return v.available; }) || list[0];
      selectedColor = next.color;
    }

    function mediaList(variant) {
      function asObj(u) {
        return typeof u === 'string' ? { jpg: u, webp: null } : u;
      }
      if (data.handle === 'the-buttress-tee' && data.images && data.images.length) {
        return data.images.map(asObj);
      }
      if (variant && variant.images && variant.images.length) {
        return variant.images.map(asObj);
      }
      if (variant && variant.featured_image) return [asObj(variant.featured_image)];
      return (data.images || []).map(asObj);
    }

    function showError(msg) {
      if (!els.error) return;
      if (!msg) {
        els.error.hidden = true;
        els.error.textContent = '';
        return;
      }
      els.error.hidden = false;
      els.error.textContent = msg;
    }

    function syncDotsAndThumbs(images) {
      if (els.dots) {
        els.dots.querySelectorAll('[data-idx]').forEach(function (btn) {
          var i = parseInt(btn.getAttribute('data-idx'), 10) || 0;
          btn.classList.toggle('is-active', i === mediaIndex);
        });
      }
      if (els.thumbs) {
        els.thumbs.querySelectorAll('[data-idx]').forEach(function (btn) {
          var i = parseInt(btn.getAttribute('data-idx'), 10) || 0;
          btn.classList.toggle('is-active', i === mediaIndex);
        });
      }
    }

    function goToSlide(index, smooth) {
      var variant = findVariant();
      var images = mediaList(variant);
      if (!images.length) return;
      if (index < 0) index = 0;
      if (index >= images.length) index = images.length - 1;
      mediaIndex = index;
      if (els.slider) {
        var w = els.slider.clientWidth || 1;
        els.slider.scrollTo({
          left: index * w,
          behavior: smooth ? 'smooth' : 'auto',
        });
      }
      syncDotsAndThumbs(images);
    }

    function renderMedia(variant) {
      var images = mediaList(variant);
      if (!images.length && data.featured_image) {
        images = [{ jpg: data.featured_image, webp: null }];
      }
      if (mediaIndex >= images.length) mediaIndex = 0;

      function slideHtml(im, i, eager) {
        if (!im || !im.jpg) return '';
        return (
          '<div class="tbp-pdp__slide"><img src="' +
          im.jpg +
          '" alt="' +
          (data.title || '') +
          ' - view ' +
          (i + 1) +
          '" width="1000" height="1000" loading="' +
          (eager ? 'eager' : 'lazy') +
          '" decoding="async"' +
          (eager ? ' fetchpriority="high"' : '') +
          '></div>'
        );
      }

      if (els.slider) {
        els.slider.innerHTML = images
          .map(function (im, i) {
            return slideHtml(im, i, i === 0);
          })
          .join('');
        els.slider.classList.toggle('is-single', images.length <= 1);
        var w = els.slider.clientWidth || 1;
        els.slider.scrollLeft = mediaIndex * w;
      }

      if (els.thumbs) {
        els.thumbs.innerHTML = images
          .slice(0, 5)
          .map(function (im, i) {
            return (
              '<button type="button" class="tbp-pdp__thumb' +
              (i === mediaIndex ? ' is-active' : '') +
              '" data-idx="' +
              i +
              '"><img src="' +
              im.jpg +
              '" alt="" width="160" height="160" loading="lazy" decoding="async"></button>'
            );
          })
          .join('');
        els.thumbs.querySelectorAll('[data-idx]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            goToSlide(parseInt(btn.getAttribute('data-idx'), 10) || 0, true);
          });
        });
      }

      if (els.dots) {
        if (images.length <= 1) {
          els.dots.innerHTML = '';
          els.dots.hidden = true;
        } else {
          els.dots.hidden = false;
          els.dots.innerHTML = images
            .map(function (_src, i) {
              return (
                '<button type="button" class="tbp-pdp__dot' +
                (i === mediaIndex ? ' is-active' : '') +
                '" data-idx="' +
                i +
                '" aria-label="Go to image ' +
                (i + 1) +
                '"></button>'
              );
            })
            .join('');
          els.dots.querySelectorAll('[data-idx]').forEach(function (btn) {
            btn.addEventListener('click', function () {
              goToSlide(parseInt(btn.getAttribute('data-idx'), 10) || 0, true);
            });
          });
        }
      }

      syncDotsAndThumbs(images);
    }

    function renderModels() {
      if (!els.models || (mode !== 'model-color' && mode !== 'model')) {
        if (els.models) els.models.hidden = true;
        if (els.modelLabel) els.modelLabel.hidden = true;
        return;
      }
      if (els.modelLabel) {
        // Covers keep "Model"; Mikaila uses "Size"; never show on undies/keychains
        if (isColorOnlyProduct) {
          els.modelLabel.hidden = true;
        } else {
          els.modelLabel.hidden = false;
          var labelSpan = els.modelLabel.querySelector('span');
          if (labelSpan) {
            labelSpan.textContent =
              data.handle === 'the-buttress-tee'
                ? 'US Size'
                : mode === 'model' && data.handle === 'the-official-mikaila-murphy-buttress-pillow'
                  ? 'Size'
                  : mode === 'model-color'
                    ? 'Model'
                    : sizeOption.name || 'Model';
          }
        }
      }
      els.models.hidden = false;
      els.models.classList.toggle('tbp-pdp__models--2', mode === 'model' || (sizeOption && sizeOption.values.length === 2));
      els.models.classList.toggle('tbp-pdp__models--3', sizeOption && sizeOption.values.length >= 3);

      var values = sizeOption.values.slice();
      if (mode === 'model-color') {
        values.sort(function (a, b) {
          var order = { ODB: 1, OMG: 2, ORT: 3 };
          return (order[modelKey(a)] || 9) - (order[modelKey(b)] || 9);
        });
      }

      els.models.innerHTML = values
        .map(function (size) {
          var sample =
            (mode === 'model-color'
              ? variantsForSize(size).find(function (v) { return v.available; }) || variantsForSize(size)[0]
              : data.variants.find(function (v) { return v.size === size && v.available; }) ||
                data.variants.find(function (v) { return v.size === size; }));
          var priceLabel =
            data.handle === 'the-buttress-tee' ? '' : sample ? money(sample.price, data.currency) : '';
          var selected = size === selectedSize ? ' is-selected' : '';
          var label = displaySizeLabel(size, data.handle);
          var priceHtml = priceLabel
            ? '<span class="tbp-pdp__model-price">' + priceLabel + '</span>'
            : '';
          return (
            '<button type="button" class="tbp-pdp__model' +
            selected +
            '" data-size="' +
            size.replace(/"/g, '&quot;') +
            '"><span class="tbp-pdp__model-name">' +
            label +
            '</span>' +
            priceHtml +
            '</button>'
          );
        })
        .join('');

      els.models.querySelectorAll('[data-size]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          selectedSize = btn.getAttribute('data-size');
          mediaIndex = 0;
          ensureColorForSize();
          render();
        });
      });
    }

    function renderColors() {
      if (!els.colors || (mode !== 'model-color' && mode !== 'color')) {
        if (els.colors) {
          els.colors.hidden = true;
          els.colors.style.display = 'none';
        }
        if (els.colorLabel) {
          els.colorLabel.hidden = true;
          els.colorLabel.style.display = 'none';
        }
        return;
      }
      if (els.colorLabel) {
        els.colorLabel.hidden = false;
        els.colorLabel.style.display = '';
        var colorSpan = els.colorLabel.querySelector('span');
        if (colorSpan) colorSpan.textContent = 'Color';
      }
      // Belt-and-suspenders: never leave a Model label on color-only PDPs
      if (isColorOnlyProduct) {
        if (els.modelLabel) {
          els.modelLabel.hidden = true;
          els.modelLabel.style.display = 'none';
        }
        if (els.models) {
          els.models.hidden = true;
          els.models.style.display = 'none';
          els.models.innerHTML = '';
        }
      }
      els.colors.hidden = false;
      els.colors.style.display = '';

      var list;
      if (mode === 'model-color') {
        // Critical: rebuild from THIS model's variants so Black/etc. show
        // ODB Black vs OMG Black vs ORT Black — not one shared swatch image.
        list = sortColors(variantsForSize(selectedSize), data.handle);
      } else {
        // Unique colors for color-only products
        var seen = {};
        list = [];
        data.variants.forEach(function (v) {
          if (!v.color || seen[v.color]) return;
          seen[v.color] = true;
          list.push(v);
        });
        list = sortColors(list, data.handle);
      }

      els.colors.innerHTML = list
        .map(function (v) {
          var selected = v.color === selectedColor ? ' is-selected' : '';
          var sold = !v.available ? ' is-soldout' : '';
          // Match gallery order: swatch = first PDP image for this variant
          var first = (mediaList(v) || [])[0] || null;
          var swatchSrc = first
            ? first.jpg || first.webp || null
            : v.featured_image || (v.images && v.images[0]) || null;
          if (swatchSrc && typeof swatchSrc === 'object') swatchSrc = swatchSrc.jpg || null;
          var img = swatchSrc
            ? '<img src="' +
              swatchSrc +
              '" alt="' +
              (v.size ? v.size + ' ' : '') +
              v.color +
              '" width="120" height="120" loading="lazy">'
            : '<span class="tbp-pdp__color-fallback">' + v.color + '</span>';
          var tag = !v.available
            ? '<span class="tbp-pdp__soldout-tag">SOLD<br>OUT</span>'
            : '';
          return (
            '<button type="button" class="tbp-pdp__color' +
            selected +
            sold +
            '" data-color="' +
            v.color.replace(/"/g, '&quot;') +
            '" data-variant-id="' +
            v.id +
            '" ' +
            (!v.available ? 'aria-disabled="true"' : '') +
            ' title="' +
            (v.size ? v.size + ' · ' : '') +
            v.color.replace(/"/g, '&quot;') +
            '">' +
            img +
            tag +
            '</button>'
          );
        })
        .join('');

      els.colors.querySelectorAll('[data-color]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.getAttribute('aria-disabled') === 'true') return;
          selectedColor = btn.getAttribute('data-color');
          mediaIndex = 0;
          render();
        });
      });
    }

    function hideModelRow() {
      if (els.modelLabel) {
        els.modelLabel.hidden = true;
        els.modelLabel.style.display = 'none';
        els.modelLabel.setAttribute('hidden', '');
      }
      if (els.models) {
        els.models.hidden = true;
        els.models.style.display = 'none';
        els.models.innerHTML = '';
        els.models.setAttribute('hidden', '');
      }
    }

    function render() {
      if (isColorOnlyProduct) {
        sizeOption = null;
        if (mode === 'model' || mode === 'model-color') mode = 'color';
        hideModelRow();
      }
      if (mode === 'model-color') ensureColorForSize();
      var variant = findVariant();
      renderModels();
      renderColors();
      if (isColorOnlyProduct) hideModelRow();
      renderMedia(variant);

      if (!variant) {
        if (els.variantInput) els.variantInput.disabled = true;
        [els.buyNow, els.addCart].forEach(function (btn) {
          if (btn) btn.disabled = true;
        });
        return;
      }

      if (els.variantInput) {
        els.variantInput.value = variant.id;
        els.variantInput.disabled = !variant.available;
      }
      if (els.price) els.price.textContent = money(variant.price, data.currency);
      if (els.compare) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          els.compare.hidden = false;
          els.compare.textContent = money(variant.compare_at_price, data.currency);
        } else {
          els.compare.hidden = true;
        }
      }

      var disabled = !variant.available;
      [els.buyNow, els.addCart].forEach(function (btn) {
        if (btn) btn.disabled = disabled;
      });
      if (els.buyNow) {
        els.buyNow.innerHTML = disabled
          ? 'Sold Out<small>Pick another option</small>'
          : 'Buy Now<small>Skip cart · checkout now</small>';
      }
      if (els.addCart) {
        els.addCart.textContent = disabled
          ? 'Sold Out'
          : 'Add to Cart — ' + money(variant.price, data.currency);
      }

      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', String(variant.id));
        window.history.replaceState({}, '', url);
      } catch (e) {}
    }

    if (els.slider && !els.slider._accBound) {
      els.slider._accBound = true;
      var ticking = false;
      els.slider.addEventListener(
        'scroll',
        function () {
          if (ticking) return;
          ticking = true;
          window.requestAnimationFrame(function () {
            ticking = false;
            var el = els.slider;
            if (!el) return;
            var w = el.clientWidth || 1;
            var idx = Math.round(el.scrollLeft / w);
            var images = mediaList(findVariant());
            if (idx < 0) idx = 0;
            if (idx >= images.length) idx = images.length - 1;
            if (idx === mediaIndex) return;
            mediaIndex = idx;
            syncDotsAndThumbs(images);
          });
        },
        { passive: true }
      );
    }

    function addToCart(thenCheckout) {
      if (!els.variantInput || els.variantInput.disabled) return;
      showError('');
      [els.buyNow, els.addCart].forEach(function (btn) {
        if (btn) btn.disabled = true;
      });
      if (els.addCart && !thenCheckout) els.addCart.textContent = 'Adding…';
      if (els.buyNow && thenCheckout) els.buyNow.innerHTML = 'Heading to checkout…';

      var payload = { items: [{ id: Number(els.variantInput.value), quantity: 1 }] };
      var variant = findVariant();

      var prepare =
        window.TBP && typeof window.TBP.syncCartAttributes === 'function'
          ? Promise.resolve(window.TBP.syncCartAttributes())
          : Promise.resolve();

      var trackItem = variant
        ? {
            id: data.id,
            productId: data.id,
            variantId: variant.id,
            title: data.title,
            price: variant.price,
            quantity: 1,
            unit: 'cents',
          }
        : null;
      // Cart totals win inside prepareAndTrackCheckout — don't stub a single-line value.
      var icOpts = variant
        ? {
            contentIds: [String(data.id)],
            unit: 'cents',
          }
        : {};

      var runner = prepare.then(function () {
        if (window.TBP && typeof window.TBP.addToCartAndRefresh === 'function') {
          return window.TBP.addToCartAndRefresh(payload, {
            checkout: !!thenCheckout,
            ic: icOpts,
            beforeCheckout: function () {
              if (window.TBP && trackItem && typeof window.TBP.trackAddToCart === 'function') {
                window.TBP.trackAddToCart(trackItem);
              }
            },
          });
        }
        return fetch(
          ((window.routes && window.routes.cart_add_url) || '/cart/add').replace(/\.js$/, '') + '.js',
          {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(payload),
          },
        ).then(function (r) {
          return r.json().then(function (json) {
            if (!r.ok || (json.status && json.status >= 400)) {
              throw new Error(json.description || json.message || 'Could not add to cart');
            }
            if (window.TBP && trackItem && typeof window.TBP.trackAddToCart === 'function') {
              window.TBP.trackAddToCart(trackItem);
            }
            if (thenCheckout) {
              if (window.TBP && typeof window.TBP.goToCheckout === 'function') {
                return window.TBP.goToCheckout({ ic: icOpts }).then(function (nav) {
                  if (nav && nav.editorBlocked) {
                    json = json || {};
                    json.editorBlocked = true;
                  }
                  return json;
                });
              }
              window.location.href = '/checkout';
              return json;
            }
            if (window.TBP && window.TBP.refreshCartDrawer) {
              return window.TBP.refreshCartDrawer({ open: true }).then(function () {
                return json;
              });
            }
            return json;
          });
        });
      });

      runner
        .then(function (json) {
          if (thenCheckout && json && json.editorBlocked) {
            showError(
              'Checkout can’t open inside the theme editor. Use Preview — item was added to cart.',
            );
            render();
            return;
          }

          // Don't rebuild gallery/swatches while navigating to checkout —
          // Safari aborts the new image loads and shows broken placeholders.
          // Buy Now: ATC fires in beforeCheckout; IC fires inside goToCheckout.
          if (thenCheckout) return;

          if (window.TBP && trackItem && typeof window.TBP.trackAddToCart === 'function') {
            window.TBP.trackAddToCart(trackItem);
          }

          render();
        })
        .catch(function (err) {
          showError((err && err.message) || 'Could not add to cart');
          render();
        });
    }

    if (els.buyNow) els.buyNow.addEventListener('click', function () { addToCart(true); });
    if (els.addCart) els.addCart.addEventListener('click', function () { addToCart(false); });

    ensureColorForSize();
    render();
  }

  function boot() {
    document.querySelectorAll('[data-tbp-accessory]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
